import LanguageSettings from './LanguageSettings'
import { FaLink, FaShieldAlt, FaUser } from 'react-icons/fa'
import { useMemo, useState } from 'react'
import {
  Flex,
  VStack,
  Text,
  Icon,
  Box,
  Show,
  useBreakpointValue,
  IconButton,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
} from '@chakra-ui/react'
import { colors } from '../../theme/cssVariables'
import TradeUrlSettings from './TradeUrlSettings'
import { IoArrowBack, IoClose } from 'react-icons/io5'
import { Trans } from '@lingui/react/macro'
import RequireAuth from '../RequireAuth'
import LoginButton from '../LoginButton'
import Menu from './Menu'
import { useAccount } from '../../hooks/useAccount'

export interface MenuItem {
  id: string
  icon?: any
  label: React.ReactNode
  component?: React.ComponentType
  link?: string
}

const menuItems: MenuItem[] = [
  // {
  //   id: 'notifications',
  //   icon: FaBell,
  //   label: 'EMAIL & PUSH SETTINGS',
  //   component: NotificationSettings,
  // },

  {
    id: 'provably-fair',
    icon: FaShieldAlt,
    label: <Trans>PROVABLY FAIR</Trans>,
    link: '/provably-fair',
  },
  // {
  //   id: 'self-care',
  //   icon: FaLock,
  //   label: 'SELF CARE',
  //   component: SelfCareSettings,
  // },
]

const rushBMenuItems: MenuItem[] = [
  {
    id: 'provably-fair',
    icon: FaShieldAlt,
    label: <Trans>PROVABLY FAIR</Trans>,
    link: 'provably-fair',
  },
]

const Settings = ({ onClose }: { onClose: () => void }) => {
  const [activeMenu, setActiveMenu] = useState<string>('')

  const { isLogin } = useAccount()

  const menu = useMemo(() => {
    return menuItems
  }, [])
  return (
    <Modal isOpen={true} onClose={onClose} size={'sm'}>
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent m="auto" minH={'300px'} bg="#1A1B23" borderRadius="xl" overflow="hidden">
        <ModalCloseButton />
        <Flex w="100%">
          <VStack w={'100%'} height={'300px'} bg="#13141A" p={6} spacing={4} align="stretch">
            <Text fontSize="2xl" fontWeight="bold" mb={6}>
              <Trans>SETTINGS</Trans>
            </Text>
            <LanguageSettings />

            {isLogin && (
              <Menu
                activeMenu={activeMenu}
                setActiveMenu={setActiveMenu}
                onClose={onClose}
                menuItems={menu}
                disabled={!isLogin}
              />
            )}
          </VStack>

          {/* <Show above="sm">
            <RequireAuth LoginDescComponent={() => <LoginDescComponent />}>
              <Box flex={1} p={8} display={'flex'} alignItems={'center'} justifyContent={'center'}>
                {ActiveComponent && <ActiveComponent />}
              </Box>
            </RequireAuth>
          </Show> */}

          {/* <Show below="sm">
            {ActiveComponent && (
              <Box
                position="fixed"
                top={0}
                left={0}
                right={0}
                bottom={0}
                bg="#1A1B23"
                zIndex={1001}
              >
                
                <Flex
                  px={4}
                  py={3}
                  alignItems="center"
                  justifyContent="space-between"
                  borderBottom={`1px solid ${colors.colorB7}`}
                  fontSize={'md'}
                >
                  <Flex alignItems="center" gap={2}>
                    <IconButton
                      aria-label="back"
                      icon={<IoArrowBack />}
                      variant="ghost"
                      onClick={handleBack}
                      size="md"
                      minW={'unset'}
                      color={colors.colorB3}
                      _hover={{}}
                      _active={{}}
                    />
                    <Text color={colors.colorB3}>
                      <Trans>Back</Trans>
                    </Text>
                  </Flex>
                  <IconButton
                    aria-label="close"
                    variant="ghost"
                    icon={<IoClose />}
                    onClick={onClose}
                    size="md"
                    minW={'unset'}
                    color={colors.colorB3}
                    _hover={{}}
                    _active={{}}
                  />
                </Flex>

                <Flex alignItems={'center'} justifyContent={'center'} px={4}>
                  <ActiveComponent />
                </Flex>
              </Box>
            )}
          </Show> */}
        </Flex>
      </ModalContent>
    </Modal>
  )
}

const LoginDescComponent = ({ isShowTitle = true }: { isShowTitle?: boolean }) => {
  return (
    <Flex
      direction={'column'}
      h={'100%'}
      alignItems={'center'}
      justifyContent={'center'}
      position={'relative'}
      minH={'300px'}
    >
      {isShowTitle && (
        <Flex alignItems={'center'} gap={2} position={'absolute'} top={0} left={0}>
          <Icon as={FaUser} w={8} color={colors.colorB4} />
          <Text>Authorization required</Text>
        </Flex>
      )}
      <Flex direction={'column'} gap={6} width={'100%'}>
        <Text>
          <Trans>To use the settings, you need to log in.</Trans>
        </Text>
        <LoginButton />
      </Flex>
    </Flex>
  )
}

export default Settings
